export const TABLET_MEDIA_QUERY_MIN_WIDTH = 768
export const DESKTOP_MEDIA_QUERY_MIN_WIDTH = 1024
export const DESKTOP_L_MEDIA_QUERY_MIN_WIDTH = 1440
export const DESKTOP_XL_MEDIA_QUERY_MIN_WIDTH = 2560

export const TABLET_MEDIA_QUERY = `(min-width: ${TABLET_MEDIA_QUERY_MIN_WIDTH}px)`
export const DESKTOP_MEDIA_QUERY = `(min-width: ${DESKTOP_MEDIA_QUERY_MIN_WIDTH}px)`
export const DESKTOP_L_MEDIA_QUERY = `(min-width: ${DESKTOP_L_MEDIA_QUERY_MIN_WIDTH}px)`
export const DESKTOP_XL_MEDIA_QUERY = `(min-width: ${DESKTOP_XL_MEDIA_QUERY_MIN_WIDTH}px)`
